export enum EApprovalPictureStatus {
  PENDING = "P",
  APPROVED = "Y",
  REJECTED = "N"
}
